import React from 'react';
import Tag from 'core/components/Tag';

const SudoTag = (props) => {
  // TODO: align sudo tag styles with design system colors
  // https://github.com/kentik/ui-app/issues/27483
  const { style, ...rest } = props;

  return (
    <Tag style={{ color: '#F7F8FD', backgroundColor: '#125480', ...style }} monospace minimal {...rest}>
      SUDO
    </Tag>
  );
};

export default SudoTag;
